import ChainAdministratorsInfo from './ChainAdministratorsInfo';

export default ChainAdministratorsInfo;
